<template>
    <i
        class="l-ss-c-offer-like-icon"
        :class="{ 'l-ss-c-offer-like-icon-active': isFavouriteOffer }"
        @click.prevent.stop="clickOnAddToFavouritesHandler($event)"
        :style="style"
        v-html="currentIcon"></i>
</template>

<script>
    import { computed } from '@vue/composition-api';

    import iconLike from '@/core/assets/images/icons/like.svg';
    import useOfferFavouritesController from '@/core/components/offer/offer-favourites/use-offer-favourites-controller';

    export default {
        props: {
            offer: {
                type: Object,
            },
            settings: {
                type: Object,
            },
            favouritesSettings: {
                type: Object,
            },
        },
        setup(props, { emit }) {
            const { offer, settings, favouritesSettings } = props;
            const { style, icon } = settings;

            const currentIcon = computed(() => {
                if (icon && icon.default) {
                    const defaultIcon = icon.default;
                    const activeIcon = icon.active;

                    if (isFavouriteOffer.value) {
                        return activeIcon || defaultIcon;
                    } else {
                        return defaultIcon;
                    }
                }

                return iconLike;
            });

            const emitAddToFavourites = (event) => {
                emit('add-to-favourites-click', event);
            };

            const emitRemoveFromFavourites = (event) => {
                emit('remove-from-favourites-click', event);
            };

            const clickOnAddToFavouritesHandler = (event) => {
                const actionType = isFavouriteOffer.value ? 'removeFromFavourites' : 'addToFavourites';

                if (actionType === 'addToFavourites') {
                    emitAddToFavourites(event);
                } else {
                    emitRemoveFromFavourites(event);
                }
                onChange(!isFavouriteOffer.value);
            };

            const { isFavouriteOffer, onChange } = useOfferFavouritesController(offer, favouritesSettings);

            return {
                currentIcon,
                style,
                isFavouriteOffer,
                onChange,
                clickOnAddToFavouritesHandler,
            };
        },
    };
</script>

<style scoped>

</style>
